module.exports = __webpack_public_path__ + "img/radio_monk.42f09117.jpg";